/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

export enum AppStates {
    Loading = 'loading',
    LoggedIn = 'loggedIn', // Portal pages
    Unauthorized = 'unauthorized', // Login page
    SessionExpired = 'sessionExpired', // Portal pages with "Session Expired" dialog
    Destroyed = 'destroyed', // Portal pages with "Web server is not responding" dialog
}
